export default "/cc9983d154542dadf4c5bf348f373c44.jpg";